// Generated by CoffeeScript 1.12.7
(function () {
  var AcceptFlowUtils, FeatureFlag;

  FeatureFlag = require("@CommonFrontendBackend/FeatureFlag").FeatureFlag;

  module.exports = AcceptFlowUtils = (function () {
    function AcceptFlowUtils(usingFeature, projectCreatorProfile, mobileBreakpoint, $timeout, $window, badgeClickUrl) {
      var branding, referralLink, referralTag, scrollTo;
      branding = projectCreatorProfile.branding;
      this.showBranding =
        branding === "white label"
          ? false
          : branding === "minimal" && usingFeature(FeatureFlag.WhiteLabelAcceptFlow)
          ? false
          : true;
      referralTag =
        branding === "white label" ? "powered-by-qwilr" : "powered-by-qwilr-impressively-beautiful-business-documents";
      referralLink =
        "//" + badgeClickUrl + "?utm_source=qwilr-branding&utm_medium=qwilr-accept-flow&utm_campaign=" + referralTag;
      this.utmMedium = "qwilr-accept-flow";
      this.goToReferralLink = function () {
        return $timeout(function () {
          return $window.open(referralLink, "_blank");
        });
      };
      this.isMobile = $(window).width() < mobileBreakpoint;
      scrollTo = function (elem) {
        return $("html, body").animate(
          {
            scrollTop: elem.offset().top,
          },
          450,
        );
      };
      this.scrollToContainerOnMobile = (function (_this) {
        return function () {
          if (_this.isMobile) {
            return scrollTo($(".accept-form-container"));
          }
        };
      })(this);
    }

    return AcceptFlowUtils;
  })();
}.call(this));
